import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        // Check facil_theme_mode
        const savedTheme = localStorage.getItem('facil_theme_mode');
        if (savedTheme === 'light' || savedTheme === 'acad' || savedTheme === 'dark') {
            return savedTheme;
        }
        // Fallback to legacy formats
        if (savedTheme === 'facil-theme-light') return 'light';
        if (savedTheme === 'facil-theme-acad') return 'acad';
        
        // Fallback to old 'hubTheme'
        const oldTheme = localStorage.getItem('hubTheme');
        if (oldTheme) {
            return oldTheme === 'dark' ? 'dark' : 'light';
        }
        
        // Default to system preference
        const systemPrefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        return systemPrefersDark ? 'dark' : 'light';
    });

    useEffect(() => {
        const root = document.documentElement;
        // Clear old classes
        root.classList.remove('dark', 'facil-theme-light', 'facil-theme-acad');

        if (theme === 'light') {
            root.classList.add('facil-theme-light');
        } else if (theme === 'acad') {
            root.classList.add('facil-theme-acad');
            root.classList.add('dark'); // keep dark active so tailwind dark: selectors and styles apply
        } else {
            root.classList.add('dark');
        }
        localStorage.setItem('facil_theme_mode', theme);
    }, [theme]);

    // Backward compatibility for existing code that checks `isDarkMode`
    const isDarkMode = theme === 'dark' || theme === 'acad';
    
    const setIsDarkMode = (val) => {
        if (typeof val === 'boolean') {
            setTheme(val ? 'dark' : 'light');
        } else {
            setTheme(val);
        }
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme, isDarkMode, setIsDarkMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    const context = useContext(ThemeContext);
    if (!context) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};
